<template>
  <div class="sidebar">
    <el-button
      type="primary"
      icon="el-icon-plus"
      size="mini"
      @click="addFn({
        child: [],
        level: 2,
        id: 0,
      })"
    >
      添加一级
    </el-button>
    <el-tree
      :data="treeList"
      default-expand-all
      highlight-current
      node-key="id"
      :props="treeProps"
      :expand-on-click-node="false"
      draggable
      :allow-drop="allowDrop"
      @node-drop="nodeDrop"
      @node-click.self="nodeClick"
    >
      <template slot-scope="{ node, data }">
        <el-popover placement="right" trigger="hover">
          <span class="op-btn-group">
            <el-button v-if="canEditList.indexOf(data.id) === -1" type="default" circle size="mini" icon="el-icon-edit-outline" @click="canEdit(data.id)" />
            <el-button type="success" circle size="mini" icon="el-icon-check" @click="saveFn(data)" />
            <el-button v-if="data.level < 4" type="primary" circle size="mini" icon="el-icon-plus" @click="addFn(data)" />
            <!--          <el-button v-if="/^new_.+$/.test(data.id)" type="default" circle size="mini" icon="el-icon-close" @click="closeFn(data)" />-->
            <el-button type="danger" circle size="mini" icon="el-icon-delete" @click="deleteFn(data)" />
          </span>
          <div slot="reference" :class="{activeItem: curSelectId === data.id}">
            <el-input v-model="data.title" :disabled="canEditList.indexOf(data.id) === -1" />
          </div>
        </el-popover>
      </template>
    </el-tree>
  </div>
</template>

<script>
import { objDeleteId, findId } from '@/utils/tool'
import { mapState } from 'vuex'

export default {
  name: 'EditSideBar',
  data() {
    return {
      // treeList: getLocal('treeList') || [],
      treeProps: {
        children: 'child'
      },
      canEditList: [],
      curSelectId: parseInt(this.$route.params.child),
      result: []
    }
  },
  computed: {
    ...mapState({
      treeList: 'class'
    })
  },
  created() {
    this.$store.dispatch('getClass', 0)
  },
  methods: {
    addFn(data) {
      const newChild = {
        id: `new_${new Date().getTime()}`,
        title: data.level === 2 ? '未命名一级分类' : '未命名二级分类',
        parent_id: data.id,
        level: data.level + 1
      }
      this.canEdit(newChild.id)
      if (!data.child) {
        this.$set(data, 'child', [])
      }
      if (data.id === 0) {
        this.treeList.push(newChild)
      } else {
        data.child.push(newChild)
        this.closeEdit(data.id)
      }
    },
    saveFn(data) {
      this.closeEdit(data.id)
      if (data.id.toString().indexOf('new_') > -1) {
        // 新增
        this.$Api.postClass({
          parent_id: data.parent_id,
          title: data.title
        }).then(res => {
          this.$message.success('新增成功')
          this.$store.dispatch('getClass', 0)
        })
      } else {
        // 修改
        this.$Api.putClass({
          id: data.id,
          parent_id: data.parent_id,
          title: data.title
        }).then(res => {
          this.$message.success('修改成功')
          this.$store.dispatch('getClass', 0)
          this.$emit('fix', data)
        })
      }
    },
    deleteFn(data) {
      this.closeEdit(data.id)
      if (data.id.toString().indexOf('new_') > -1) {
        // 本地删除
        this.treeList = objDeleteId(this.treeList, data.id, 'child')
        this.$message.success('删除新建项')
      } else {
        // 线上删除
        this.$confirm(`此操作将永久删除"${data.title}", 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Api.deleteClass({
            id: data.id
          }).then(res => {
            this.$message.success('删除该项成功')
            this.$store.dispatch('getClass', 0)
          })
        }).catch(() => {})
      }
    },
    // 开启编辑
    canEdit(id) {
      this.canEditList = this.canEditList.filter(item => item !== id)
      this.canEditList.unshift(id)
      this.canEditList = this.canEditList.slice(0, 10)
    },
    // 关闭编辑
    closeEdit(id) {
      this.canEditList = this.canEditList.filter(item => item !== id)
    },
    // 关闭所有编辑
    closeAllEdit() {
      this.canEditList = []
    },
    getStandard(parameter) {
      // 查询标准文件
      this.$Api.getStandard(parameter).then(res => {
      })
    },
    nodeClick(data, b, c) {
      if (data.level >= 3 && data.id.toString().indexOf('new_') === -1) {
        if (this.curSelectId !== data.id) {
          this.$emit('select', data)
        }
        this.curSelectId = data.id
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      const dragLevel = draggingNode.data.level
      const dropLevel = dropNode.data.level
      if (dragLevel === dropLevel) {
        return type !== 'inner'
      } else if ((dragLevel - dropLevel) === 1) {
        return type === 'inner'
      }
      return false
    },
    nodeDrop(draggingNode, dropNode, dropType, ev) {
      const dragLevel = draggingNode.data.level
      const dragPid = draggingNode.data.parent_id
      const dropPid = dropNode.data.parent_id
      const dropId = dropNode.data.id
      const dropLevel = dropNode.data.level
      if (dragLevel === dropLevel) {
        let aa = []
        let bb = []
        if (dragPid === dropPid) {
          aa = this.dropFn(dropPid)
        } else {
          bb = this.dropFn(dragPid)
          aa = this.dropFn(dropPid)
        }
        console.log(aa, bb)
        this.putSort([...aa, ...bb])
      } else if ((dragLevel - dropLevel) === 1) {
        let aa = []
        aa = this.dropFn(dropId)
        this.putSort([...aa])
      } else {
        this.$store.dispatch('getClass', 0)
        this.$message.warning('拖拽的两个对象不是同一级')
      }
    },
    dropFn(Pid) {
      this.result = []
      findId(this.treeList, (item) => {
        return item.id === Pid.toString()
      }, this.result, 'child')
      if (this.result.length) {
        return this.result[0].child.map((item, index) => ({
          id: parseInt(item.id),
          parent_id: Pid,
          sort: index + 1
        }))
      }
      return []
    },
    putSort(temp) {
      this.$Api.putSort({
        classifications: temp
      }).then(res => {
        this.$store.dispatch('getClass', 0)
        this.$notify.success('修改菜单成功')
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .sidebar{
    width: 280px;
    padding: 28px 34px;
    border: 1px solid #EDEDEF;
    background-color: #fff;
    user-select: none;
  }
  /deep/ .el-tree{
    .el-tree-node__content{
      height: 60px;
      padding-right: 20px;
      &:hover{
        /* todo 做成延时动画 */
        .op-btn-group{
          display: inline-block;
        }
      }
       .el-input{
         &.is-disabled{
           .el-input__inner{
             background-color: #fff;
             color: #606266;
           }
         }
       }
      .op-btn-group{
        display: none;
      }
    }
    .el-tree-node.is-current>.el-tree-node__content{
      background-color: rgba(205, 224, 246, 0.5);
    }
  }
</style>
